// extracted by mini-css-extract-plugin
export default {"main":"styles_main__8JviW","store":"styles_store__1Yawn","menu":"styles_menu__MMfWo","container":"styles_container__kl7D+","top":"styles_top__dGk+E"};